import React, { useRef, useState, useEffect } from 'react';
import Lottie from 'lottie-react';

const EssenceSection = ({ translations = {} }) => {
  const lottieRef = useRef();
  const audioRef = useRef();
  const [animationData, setAnimationData] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);

  // Cargar la animación JSON
  useEffect(() => {
    fetch('/images/cheers.json')
      .then(response => response.json())
      .then(data => setAnimationData(data))
      .catch(error => console.error('Error loading animation:', error));
  }, []);

  const handleCheersClick = () => {
    // Prevenir múltiples clics
    if (isPlaying) return;
    
    setIsPlaying(true);
    
    // Reproduce la animación
    if (lottieRef.current) {
      lottieRef.current.goToAndPlay(0, true);
    }
    
    // Reproduce el sonido después de 1 segundo
    setTimeout(() => {
      if (audioRef.current) {
        audioRef.current.currentTime = 0;
        audioRef.current.play().catch(error => {
          console.log('Error playing audio:', error);
        });
      }
      
      // Permitir nuevos clics después de que termine
      setTimeout(() => {
        setIsPlaying(false);
      }, 1000);
    }, 1000);
  };

  // Función para obtener el saludo según el idioma
  const getCheersText = () => {
    if (translations.essenceTitle) {
      // Si hay traducciones, detectar el idioma basado en el contenido
      const title = translations.essenceTitle.toLowerCase();
      if (title.includes('essence') || title.includes('our')) {
        return 'CHEERS!';
      } else if (title.includes('esencia') || title.includes('nuestra')) {
        return 'SALUD!';
      } else {
        return 'ΓΕΙΑ ΜΑΣ!'; // Griego
      }
    }
    // Si no hay traducciones específicas, usar inglés por defecto
    return 'CHEERS!';
  };

  return (
    <section className="py-20 bg-[#FFF8F0] text-gray-800 relative overflow-hidden">
      <div className="container mx-auto px-4 relative z-10">
        <h2
          className="text-4xl font-bold text-center text-[#FF4C29] mb-12 animate-fade-in"
          style={{ animationDelay: '0.2s' }}
        >
          {translations.essenceTitle || 'Our Essence'}
        </h2>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="animate-zoom-in" style={{ animationDelay: '0.4s' }}>
            <img
              src="/images/latin-cocktail.jpg"
              alt="Latin American Cocktails"
              className="rounded-2xl shadow-xl transform hover:scale-105 transition-transform duration-300 ease-in-out w-full"
            />
          </div>
          <div className="space-y-6 animate-slide-in-right" style={{ animationDelay: '0.6s' }}>
            <p className="text-lg leading-relaxed">
              {translations.essenceParagraph1 ||
                'El Latino Cafe te trae el alma de América Latina con cócteles vibrantes como mojitos, pisco sours y caipirinhas, y comidas rápidas típicas como empanadas y arepas, llenas de sabor y tradición.'}
            </p>
            <p className="text-lg leading-relaxed">
              {translations.essenceParagraph2 ||
                'Disfruta de auténticas comidas rápidas latinas como tacos y ceviche, junto a cócteles que capturan la esencia de la región, todo servido en un ambiente lleno de vida y pasión cultural.'}
            </p>
            
            {/* Texto Cheers en tres idiomas con animación Lottie */}
            <div className="flex items-center justify-center mt-8 space-x-4">
              <div className="text-center">
                <p className="text-xl font-bold text-[#FF4C29] mb-2">
                  {getCheersText()}
                </p>
                <div 
                  className={`cursor-pointer w-24 h-24 mx-auto ${isPlaying ? '' : 'animate-pulse-scale'}`}
                  onClick={handleCheersClick}
                  onTouchStart={handleCheersClick}
                >
                  {animationData && (
                    <Lottie
                      lottieRef={lottieRef}
                      animationData={animationData}
                      autoplay={false}
                      loop={false}
                      style={{ width: '100%', height: '100%' }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Audio element para el sonido */}
      <audio
        ref={audioRef}
        preload="auto"
      >
        <source src="/sounds/cheers.mp3" type="audio/mpeg" />
        Your browser does not support the audio element.
      </audio>

      <style jsx>{`
        @keyframes pulse-scale {
          0% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.1);
          }
          100% {
            transform: scale(1);
          }
        }

        .animate-pulse-scale {
          animation: pulse-scale 2s ease-in-out infinite;
        }
      `}</style>
    </section>
  );
};

export default EssenceSection;